import React, { useEffect, useRef, useState } from "react";
import CourseApi from "../api/services/CourseApi";
import InfiniteScroll from "react-infinite-scroll-component";
import Skeleton from "react-loading-skeleton";
import scrollToTop from "../components/ScrollTop/ScrollTop";
import BackButton from "../components/microComponents/BackButton";
import { useParams } from "react-router-dom";
import Urls from "../api/Urls";
import SearchInput from "../components/microComponents/SearchInput";
import EmptyTranslateView, {
  EmptyTranslateViewRef,
} from "../components/microComponents/EmptyTranslateView";
import PdfLessonHeader from "../components/PdfLessonHeader/PdfLessonHeader";

const skeleton = (
  <>
    <div className="patenteBoiMain">
      {[...Array(6)].map((_, index) => (
        <div className="patenteBoiItem" key={index}>
          <div className="patenteBoiImg">
            <Skeleton width={100} height={100} />
            <p>
              <Skeleton width={100} />
            </p>
          </div>
          <div className="patenteBoiDetails">
            <Skeleton count={3} />
          </div>
        </div>
      ))}
    </div>
  </>
);

const PatenteBoi = () => {
  const { chapterId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [wordList, setWordList] = useState<any[]>([]);
  const [nextPageNo, setNextPageNo] = useState(0);
  const [chapterLesson, setChapterLesson] = useState<string>("");
  const [searchText, setSearchText] = useState<string>("");
  const emptyTranslateViewRef = useRef<EmptyTranslateViewRef>(null);

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    // fetchApiData();
    // emptyTranslateViewRef?.current?.hideTranslateResult();
    if (searchText.length > 0) {
      fetchSearchApiData(searchText);
    } else {
      fetchApiData();
    }
  }, [searchText]);

  const fetchSearchApiData = (text: string) => {
    setIsLoading(true);

    CourseApi.getImportantNotesByWord(Number(chapterId), text, {
      onSuccess: (response) => {
        // console.log('response', response);
        setIsLoading(false);
        setWordList(response.data);
        setNextPageNo(response?.meta?.next_page_url ? 2 : 0);
      },
      onError: () => setIsLoading(false),
    });
  };

  const fetchApiData = () => {
    setIsLoading(true);

    CourseApi.getImportantNotesByChapter(Number(chapterId), 1, {
      onSuccess: (response) => {
        setIsLoading(false);
        setWordList(response.data);
        setNextPageNo(response?.meta?.next_page_url ? 2 : 0);
      },
      onError: () => setIsLoading(false),
    });

    CourseApi.getDetails(Number(chapterId), {
      onSuccess: (response) => {
        // console.log('response', response);
        setChapterLesson(response.data.chapter_lesson);
      },
      onError: () => setIsLoading(false),
    });
  };

  /**
   * This funtion fetch more data
   */
  const handleLoadMore = () => {
    // console.log('called handleLoadMore');
    if (!isLoading && nextPageNo > 0) {
      setIsLoading(true);
      CourseApi.getImportantNotesByChapter(Number(chapterId), nextPageNo, {
        onSuccess: (response) => {
          setIsLoading(false);
          setWordList(
            response?.data ? [...wordList, ...response.data] : [...wordList]
          );
          setNextPageNo(response?.meta?.next_page_url ? nextPageNo + 1 : 0);
        },
        onError: () => setIsLoading(false),
      });
    }
  };

  return (
    <div className="Container">
      <BackButton title={"সহজ পাতেন্তে বই"} isSticky={true} />

      <SearchInput
        placeholder={"Type word to search"}
        onValueChange={(value) => setSearchText(value)}
        onClearPress={() => setSearchText("")}
        className="dictionary-search"
      />

      <PdfLessonHeader chapterLesson={chapterLesson} />

      {isLoading && wordList.length === 0 ? (
        skeleton
      ) : wordList.length === 0 && searchText.trim() ? (
        <EmptyTranslateView
          ref={emptyTranslateViewRef}
          translateText={searchText}
        />
      ) : (
        <InfiniteScroll
          dataLength={wordList?.length}
          next={handleLoadMore}
          hasMore={nextPageNo > 0 ? true : false}
          loader={skeleton}
          // endMessage={<h4>No more items</h4>}
        >
          <div className="patenteBoiMain">
            {wordList?.map((item) => (
              <div className="patenteBoiItem" key={item.id}>
                <div className="patenteBoiImg">
                  {item.image && (
                    <img src={Urls.storagePath + item.image} alt="" />
                  )}
                  <p>{item?.word}</p>
                </div>
                <div
                  className="patenteBoiDetails"
                  dangerouslySetInnerHTML={{ __html: item.meaning }}
                />
              </div>
            ))}
          </div>
        </InfiniteScroll>
      )}
    </div>
  );
};

export default PatenteBoi;
